import script from "./Gallery.vue?vue&type=script&setup=true&lang=js"
export * from "./Gallery.vue?vue&type=script&setup=true&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=5e127a7d&lang=scss&scoped=true"

import exportComponent from "/Users/clopez/Documents/Repositorios/Muevetec/landing-muevetec-base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e127a7d"]])

export default __exports__